import { useEffect, useRef, useState } from "react";

// One panel = one request. Each panel loads independently so the page paints
// progressively and a slow panel never blanks the others. A stale response
// (filters changed mid-flight) is dropped rather than painted.
export default function usePanel(fetcher, filters, enabled = true) {
  const [state, setState] = useState({ loading: enabled, data: null, error: null });
  const seq = useRef(0);

  useEffect(() => {
    if (!enabled) return undefined;
    const mySeq = ++seq.current;
    setState((s) => ({ ...s, loading: true, error: null }));
    fetcher(filters)
      .then((res) => {
        if (seq.current === mySeq) setState({ loading: false, data: res.data, error: null });
      })
      .catch((err) => {
        if (seq.current === mySeq) {
          const detail = err?.response?.data?.detail;
          setState({ loading: false, data: null, error: detail || err?.message || "Could not load" });
        }
      });
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetcher, enabled, filters.start, filters.end, (filters.practiceAreas || []).join(","), (filters.attorneys || []).join(","), filters.includeArchived, filters._r]);

  return state;
}
